export default (node)=>({
  links: [
    {
      path: "/app/clients",
      label: "Personal Info",
    },
    // {
    //   path: "/app/clients/company_info",
    //   label: "Company Info"
    // },
    // {
    //   path: "/app/clients/business_info",
    //   label: "Business Info"
    // },
    // {
    //   path: "/app/clients/doc_upload",
    //   label: "Doc Upload"
    // }
  ],
  columns: [
    {
      type: "select",
      dataIndex: "partner_type",
      title: "Partner Type",
      options:enums.OnboardTypes,
      required:true,
      hasFilter:true
    },
    {
      type: "select",
      dataIndex: "company_type",
      title: "Entity Type",
      options:enums.industry,
      required:true,
      hasFilter:true
    },
    {
      type: "text",
      dataIndex: "company_name",
      title: "Entity Name",
      required:true
    },
    {
      type: "select",
      dataIndex: "bank_name",
      title: "Bank Name",
      options:enums.BankList.options(),
      required:true
    },
    {
      type: "select",
      dataIndex: "account_type",
      options:enums.AccountTypes,
      title: "Account Type",
      required:true
    },
    {
      type: "text",
      dataIndex: "account_num",
      title: "Account Number",
      required:true
    },
    {
      type: "text",
      dataIndex: "ifsc",
      title: "IFSC Code",
      required:true
    },
    {
      type: "text",
      dataIndex: "branch_name",
      title: "Bank Name",
      required:true
    },
    {
      type: "select",
      dataIndex: "verification_status",
      title: "Verification Status",
      options:[{key:"verified",value:"Varified"}],
      required:true
    },
    {
      type: "email",
      dataIndex: "email_address",
      title: "Email Address",
      required:true
    },
    {
      type: "number",
      dataIndex: "contact_number",
      title: "Phone No.",
      required:true
    },
    {
      type: "number",
      dataIndex: "alt_contact_number",
      title: "Alternate Contact Number",
      required:true,
      notintable:true,
      notinform:true
    },
    {
      type: "text",
      dataIndex: "aadhar_number",
      title: "Aadhar No.",
      pattern:"^[0-9]{12}$",
      required:true,
      notintable:true
    },
    {
      type: "text",
      pattern:'^[A-Z]{5}[0-9]{4}[A-Z]{1}$',
      dataIndex: "company_pan_number",
      title: "Pan No.",
      required:true,
      notintable:true
    },
    {
      type: "text",
      pattern:"^([0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}[Z]{1}[0-9A-Z]{1})$",
      dataIndex: "gstin_id",
      title: "GST Registration No.",
      required:true
    },
    {
      type:"filepassword",
      dataIndex:"company_pancard",
      title:"Upload PAN Card",
      onChange:(e) => node.uploadDocument(e,'company_pancard'),
      haspassword:false,
      required:true,
      notintable:true
    },
    {
      type:"filepassword",
      dataIndex:"company_cheque",
      title:"Upload Cancelled Cheque",
      onChange:(e) => node.uploadDocument(e,'company_cheque'),
      haspassword:false,
      required:true,
      notintable:true
    },
    {
      type:"filepassword",
      dataIndex:"authorisation_letter",
      title:"Dealer / Distribution Authorization letter",
      onChange:(e) => node.uploadDocument(e,'authorisation_letter'),
      haspassword:false,
      required:true,
      notintable:true
    }
  ],
  fields(arr, excludes = []) {
    return this.columns
      .map((obj) => ({
        ...Object.except(obj, ["dataIndex", "hasFilter", "className"]),
        name: obj.dataIndex,
        label: obj.title || obj.dataIndex.toTitleCase(),
        required: true,
        ...(arr.find((o) => o.name == obj.dataIndex)
          ? arr.find((o) => o.name == obj.dataIndex)
          : {}),
      }))
      .filter((o) => !excludes.includes(o.name))
      .filter((o) => !o.notinform);
  },
});
